const calculateTotalVnd = (selectedItems: IIngotItemInfo[]) => {
    if (!selectedItems || selectedItems.length <= 0) {
        return 0
    }
    let amount = selectedItems
        .map(value => value.valueInVnd * value.num)
        .reduce((previousValue, currentValue) => previousValue + currentValue)
    return (Math.ceil(amount / 1000) * 1000)
}

const calculateTotalCoin = (selectedItems: IIngotItemInfo[]) => {
    if (!selectedItems || selectedItems.length <= 0) {
        return 0
    }
    return selectedItems
        .map(value => value.value * value.num)
        .reduce((previousValue, currentValue) => previousValue + currentValue)
}

export const ExchangeUtils = {
    calculateTotalVnd,
    calculateTotalCoin
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/ExchangeStore/ExchangeUtils.ts